import { render, staticRenderFns } from "./DodEmployeeDetails.vue?vue&type=template&id=4ae2a868&scoped=true&"
import script from "./DodEmployeeDetails.vue?vue&type=script&lang=js&"
export * from "./DodEmployeeDetails.vue?vue&type=script&lang=js&"
import style0 from "./DodEmployeeDetails.vue?vue&type=style&index=0&id=4ae2a868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2a868",
  null
  
)

export default component.exports